import { intervalToDuration } from "date-fns";

const zeroPad = (num?: number) => (num ? String(num) : "").padStart(2, "0");

export const durationFromSeconds = (s: number) => {
  const { hours, minutes, seconds } = intervalToDuration({
    start: 0,
    end: s * 1000,
  });

  return `${zeroPad(hours)}:${zeroPad(minutes)}:${zeroPad(seconds)}`;
};
